import {styled} from "@mui/material/styles";
import ToggleButtonGroup, {
	toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup';

export const CoverageItem = styled("div")(() => ({
	padding: 0,
	minWidth: 205,
	height: '100%',
	minHeight: '175px',
	borderRadius:'4px',
}))

export const TotalBlock = styled("div")(({theme}) => ({
	backgroundColor:  theme.palette.primary.main,
	padding: '24px 12px',
	color: theme.palette.background.default,
	borderRadius: '0 0 8px 8px',
}))

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
	[`& .${toggleButtonGroupClasses.grouped}`]: {
		'& h6': {
			textTransform: 'capitalize',
			color: theme.palette.background.default,
		},
		'&:hover': {
			'& h6': {
				color: theme.palette.primary.main,
			},
			backgroundColor: theme.palette.background.default,
		},
		'&.Mui-selected': {
			'&:hover': {
				'& h6': {
					color: theme.palette.primary.main,
				},
				backgroundColor: theme.palette.background.default,
			},
			'& h6': {
				color: theme.palette.primary.main,
			},
			backgroundColor: theme.palette.background.default,
			border: `1px solid ${theme.palette.background.default}`,
		},
		padding: '7px 10px',
		borderColor: theme.palette.background.default,
	},
}));
